import { render, staticRenderFns } from "./ApplicantApplicationDetailsPageV2.vue?vue&type=template&id=64b2fa52&"
import script from "./ApplicantApplicationDetailsPageV2.vue?vue&type=script&lang=ts&"
export * from "./ApplicantApplicationDetailsPageV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b2fa52')) {
      api.createRecord('64b2fa52', component.options)
    } else {
      api.reload('64b2fa52', component.options)
    }
    module.hot.accept("./ApplicantApplicationDetailsPageV2.vue?vue&type=template&id=64b2fa52&", function () {
      api.rerender('64b2fa52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/Application/ApplicantApplicationDetailsPageV2.vue"
export default component.exports